<script lang="ts" setup>
import sliderImage1 from '/assets/images/token/image-1.webp'
import sliderImage2 from '/assets/images/token/image-2.webp'
import sliderImage3 from '/assets/images/token/image-3.webp'

import InstallSection from '~/components/InstallSection.vue'
import accessEngagement from '/assets/images/token/access-engagement.svg'
import rewardsIncentives from '/assets/images/token/rewards-incentives.svg'
import stakingGovernance from '/assets/images/token/staking-governance.svg'
import transactionMedium from '/assets/images/token/transaction-medium.svg'

import Closed from '/assets/images/token/closed.svg?component'

const { t } = useI18n()
const localeRoute = useLocaleRoute()

const {
  public: { siteUrl },
} = useRuntimeConfig()

useSeoMeta({
  title: 'Long TOKENOMICS',
  description: t('token-gate-your-private'),
  ogTitle: 'Long TOKENOMICS',
  ogDescription: t('token-gate-your-private'),
  ogImage: `${siteUrl}/images/token/preview.webp`,
  ogImageWidth: '1200',
  ogImageHeight: '630',
  ogType: 'website',
  twitterTitle: 'Long TOKENOMICS',
  twitterDescription: t('token-gate-your-private'),
  twitterImage: `${siteUrl}/images/token/preview.webp`,
  twitterCard: 'summary_large_image',
})

definePageMeta({
  layout: 'base',
})

const sliderArray = [
  {
    id: 0,
    image: sliderImage1,
    title: t('the-long-protocol-is-revolutionizing'),
  },
  {
    id: 1,
    image: sliderImage2,
    title: t('belong-the-platform-provides'),
  },
  {
    id: 2,
    image: sliderImage3,
    title: t('together-they-re-shaping'),
  },
]

const tokenUtilityAndFunctionality = [
  {
    id: 0,
    image: accessEngagement,
    title: t('access-engagement'),
    description: t('token-holders-gain-exclusive-access'),
  },
  {
    id: 0,
    image: stakingGovernance,
    title: t('staking-governance'),
    description: t('users-can-stake-long-tokens'),
  },
  {
    id: 0,
    image: rewardsIncentives,
    title: t('rewards-incentives'),
    description: t('the-tokenomics-include-a-rewards-system'),
  },
  {
    id: 0,
    image: transactionMedium,
    title: t('transaction-medium'),
    description: t('long-facilitates-transactions'),
  },
]

const tokenCirculationEconomics = [
  {
    id: 0,
    title: 'Seed',
    price: '0.008',
    tge: '4.00%',
    cliff: '6',
    vesting: '24',
    percent: '14%',
  },
  {
    id: 1,
    title: 'Private',
    price: '0.015',
    tge: '7.00%',
    cliff: '4',
    vesting: '20',
    percent: '9.67%',
  },
  {
    id: 2,
    title: 'Kol',
    price: '0.0015',
    tge: '5.00%',
    cliff: '-',
    vesting: '6',
    percent: '3.00%',
  },
  {
    id: 3,
    title: 'Public',
    price: '0.03',
    tge: '15.00%',
    cliff: '3',
    vesting: '6',
    percent: '3.33%',
  },
  {
    id: 4,
    title: 'Team',
    tge: '0.00%',
    cliff: '12',
    vesting: '24',
    percent: '10%',
  },
  {
    id: 5,
    title: 'Liquidity',
    tge: '30.00%',
    cliff: '-',
    vesting: '24',
    percent: '8%',
  },
  {
    id: 6,
    title: 'Rewards',
    tge: '0.00%',
    cliff: '-',
    vesting: '48',
    percent: '25.00%',
  },
  {
    id: 7,
    title: 'Advisors',
    tge: '0.00%',
    cliff: '5',
    vesting: '24',
    percent: '5.00%',
  },
  {
    id: 8,
    title: 'Reserve Fund',
    tge: '0.00%',
    cliff: '12',
    vesting: '36',
    percent: '18.00%',
  },
  {
    id: 9,
    title: 'Community support',
    tge: '10.00%',
    cliff: '3',
    vesting: '12',
    percent: '4.00%',
  },
]

const tokenAllocation = [
  {
    id: 0,
    title: 'Community support',
    percent: '4.0%',
    color: '#21285F',
  },
  {
    id: 1,
    title: 'Reserve Fund',
    percent: '18.0%',
    color: '#DDA6CB',
  },
  {
    id: 2,
    title: 'Advisors',
    percent: '5.0%',
    color: '#E8698F',
  },
  {
    id: 3,
    title: 'Rewards',
    percent: '25.0%',
    color: '#B990C1',
  },
  {
    id: 4,
    title: 'Liquidity',
    percent: '8.0%',
    color: '#EC90BC',
  },
  {
    id: 5,
    title: 'Seed',
    percent: '14.0%',
    color: '#87CBF1',
  },
  {
    id: 6,
    title: 'Private',
    percent: '9.7%',
    color: '#66428F',
  },
  {
    id: 7,
    title: 'Kol',
    percent: '3.0%',
    color: '#5D8BCF',
  },
  {
    id: 8,
    title: 'Public',
    percent: '3.3%',
    color: '#BD71CC',
  },
  {
    id: 9,
    title: 'Team',
    percent: '10.0%',
    color: '#FFE08C',
  },
]

const tokensByMonth = [
  {
    id: 0,
    color: '#DDA6CB',
    title: 'Reserve Fund',
  },
  {
    id: 1,
    color: '#E8698F',
    title: 'Advisors',
  },
  {
    id: 2,
    color: '#B990C1',
    title: 'Rewards',
  },
  {
    id: 3,
    color: '#EC90BC',
    title: 'Liquidity',
  },
  {
    id: 4,
    color: '#FFE08C',
    title: 'Team',
  },
  {
    id: 5,
    color: '#BD71CC',
    title: 'Public',
  },
  {
    id: 6,
    color: '#5D8BCF',
    title: 'Kol',
  },
  {
    id: 7,
    color: '#66428F',
    title: 'Private',
  },
  {
    id: 8,
    color: '#87CBF1',
    title: 'Seed',
  },
]
</script>

<template>
  <section>
    <div
      class="relative rounded-[1.25rem] overflow-hidden mx-5 max-w-309 h-65 md:h-144.5 xl:mx-auto"
    >
      <NuxtImg
        loading="lazy"
        v-motion
        :initial="{
          x: -200,
        }"
        :enter="{
          x: 0,
          transition: {
            duration: 5000,
          },
        }"
        alt="t('the-future-of-content-monetization-is-here-0')"
        class="min-w-360 lg:h-144.5 object-cover"
        src="/images/token/long-tokenomics.webp"
      />

      <NuxtImg
        loading="lazy"
        format="webp"
        v-motion
        :initial="{
          opacity: 0,
        }"
        :enter="{
          opacity: 1,
          transition: {
            duration: 2000,
          },
        }"
        alt="t('the-future-of-content-monetization-is-here-0')"
        src="/images/token/long-tokenomics.png"
        class="w-full h-full object-cover absolute top-0"
      />

      <div
        class="absolute left-5 bottom-8 max-w-74 lg:max-w-full lg:left-17.5 lg:bottom-18.5"
      >
        <div
          class="animation-block-text text-4xl leading-[2.75rem] font-light lg:!text-[4.25rem] lg:leading-[4.625rem] lg:tracking-wide"
        >
          <div
            v-motion="{
              initial: {
                opacity: 0,
              },
              enter: {
                opacity: 1,
                transition: {
                  delay: 2000,
                  duration: 1000,
                },
              },
            }"
          >
            <span
              class="inline-flex justify-center items-center bg-[#B696FF] text-white h-11.5 rounded-full px-4 lg:h-17.5"
              >$LONG</span
            >
          </div>
          <div
            v-motion="{
              initial: {
                opacity: 0,
              },
              enter: {
                opacity: 1,
                transition: {
                  delay: 2000,
                  duration: 1000,
                },
              },
            }"
          >
            TOKENOMICS
          </div>
        </div>
      </div>
    </div>
  </section>

  <section>
    <div
      class="flex flex-col px-5 gap-5 justify-center pt-10 pb-8 sm:flex-row sm:flex-wrap sm:pt-32.5 sm:gap-6 sm:pb-10"
    >
      <div
        v-for="item in sliderArray"
        :key="item.id"
        v-motion="{
          initial: {
            opacity: 0,
          },
          visibleOnce: {
            opacity: 1,
            transition: {
              duration: 1000,
            },
          },
        }"
        class="slider-content flex flex-col min-h-70 gap-6 relative overflow-hidden rounded-[1.25rem] p-6 w-full sm:w-81 sm:min-h-84 border border-solid border-[#e0bdff21]"
      >
        <img
          class="w-20 h-20 sm:w-24 sm:h-24 object-cover"
          :alt="item.title"
          :src="item.image"
        />
        <p
          class="text-[#E0BDFF] text-sm sm:text-base tracking-wider leading-normal"
        >
          {{ item.title }}
        </p>
        <img
          v-if="item.id === 1"
          alt="Mask"
          class="absolute bottom-0 left-0 right-0 -z-1 mx-auto"
          src="/assets/images/token/mask.svg"
        />
      </div>
    </div>
  </section>

  <section>
    <div class="max-w-268 mx-auto pb-10 px-5 pt-0 xl:px-0 xl:pt-10 xl:pb-16.5">
      <div
        v-motion="{
          initial: {
            opacity: 0,
            y: 20,
          },
          visibleOnce: {
            y: 0,
            opacity: 1,
            transition: {
              duration: 500,
              type: 'keyframes',
              ease: 'easeIn',
            },
          },
        }"
      >
        <p class="text-2xl md:text-[2rem] tracking-wide">
          {{ t('token-utility-and-functionality') }}
        </p>
        <p
          class="text-sm leading-normal md:text-[1.25rem] text-[#ABABAB] max-w-173.5 tracking-wide mt-6"
        >
          {{ t('the-long-token-an-erc20-token') }}
        </p>
      </div>
      <div
        class="flex flex-col gap-5 mt-6 sm:flex-row sm:flex-wrap sm:gap-6 sm:mt-13"
      >
        <div
          v-for="item in tokenUtilityAndFunctionality"
          :key="item.id"
          class="flex w-full min-h-45.5 h-full xl:w-auto xl:max-w-131 xl:min-h-64.5 bg-[#FFFFFF05] rounded-[1.25rem] border border-solid border-[#FFFFFF21]"
          v-motion="{
            initial: {
              opacity: 0,
            },
            visibleOnce: {
              opacity: 1,
              transition: {
                duration: 500,
                type: 'keyframes',
                ease: 'easeIn',
              },
            },
          }"
        >
          <div
            class="flex flex-col items-start gap-3.5 pt-3.5 pb-5 xl:py-6.5 xl:gap-5 pl-2"
          >
            <div class="flex flex-row items-center gap-3.5">
              <div
                class="bg-[#221A22] w-11 h-11 rounded-full flex items-center justify-center"
              >
                <img :alt="item.title" :src="item.image" />
              </div>
              <p
                class="text-xl xl:text-[1.75rem] text-[#FFB0F0] break-all pr-10"
              >
                {{ item.title }}
              </p>
            </div>
            <p class="text-sm xl:text-lg ml-15 pr-2">
              {{ item.description }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section>
    <div class="max-w-268 mx-auto pt-0 px-5 xl:px-0 xl:py-10">
      <div
        class="flex flex-col"
        v-motion="{
          initial: {
            opacity: 0,
            y: -20,
          },
          visibleOnce: {
            y: 0,
            opacity: 1,
            transition: {
              duration: 500,
              type: 'keyframes',
              ease: 'easeIn',
            },
          },
        }"
      >
        <p class="text-2xl md:text-[2rem] tracking-wide text-[#E0BDFF]">
          {{ t('belong-token-flow') }}
        </p>
        <p
          class="text-sm leading-normal md:text-[1.25rem] text-[#ABABAB] max-w-173.5 tracking-wide mt-6"
        >
          {{ t('this-multifaceted-utility') }}
        </p>
      </div>

      <div class="max-w-228.75 mt-5 mx-auto xl:mr-0 xl:ml-auto xl:mt-13">
        <client-only>
          <Lottie src="/lottie/token-flow.json" loop autoplay />
        </client-only>
      </div>
    </div>
  </section>

  <section>
    <div class="max-w-268 mx-auto relative py-8 lg:py-10">
      <div class="flex flex-col px-5">
        <p class="text-2xl md:text-[2rem] tracking-wide">
          {{ t('token-circulation-economics') }}
        </p>

        <div
          class="flex flex-col items-center gap-13 lg:flex-row lg:items-start lg:gap-34"
        >
          <client-only>
            <div class="mt-13 w-57 md:mt-22.5 md:w-72.5">
              <Lottie
                src="/lottie/token-circulation-economics.json"
                loop
                autoplay
              />
            </div>
          </client-only>
          <div class="flex flex-col items-start lg:pt-12.5 gap-6">
            <p class="text-[1.25rem] font-light text-[#E0BDFF]">
              {{ t('staking-and-rewards') }}
            </p>
            <p
              class="text-white/40 font-light text-sm md:text-lg lg:max-w-132.5"
              v-motion="{
                initial: {
                  opacity: 0,
                  y: 20,
                },
                visibleOnce: {
                  y: 0,
                  opacity: 1,
                  transition: {
                    duration: 500,
                    type: 'keyframes',
                    ease: 'easeIn',
                  },
                },
              }"
            >
              {{ t('in-the-larger-ecosystem') }}
              <br />
              <br />
              {{ t('crucially-the-annual') }}
              <br />
              <br />
              {{ t('this-system-effectively') }}
            </p>
            <div
              v-motion="{
                initial: {
                  x: -100,
                  opacity: 0,
                },
                visibleOnce: {
                  x: 0,
                  opacity: 1,
                  transition: {
                    duration: 500,
                    type: 'keyframes',
                  },
                },
              }"
              class="w-full sm:w-auto"
            >
              <a
                href="https://x9sujmtmm4g.typeform.com/to/Y7koFY8l"
                target="_blank"
                class="flex flex-row items-center justify-center sm:justify-start gap-3.5 border border-solid border-[#7540EE] hover:bg-[#7540EE] rounded-full py-2.5 px-6"
              >
                <p>{{ t('read-more') }}</p>
                <img alt="Read" src="/assets/images/token/read-more.svg" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section>
    <div class="py-8 md:py-10 relative">
      <div
        class="flex flex-row pb-8 md:flex-row md:w-full md:pb-10 flex-wrap px-5 gap-col-5 gap-row-6 max-w-268 mx-auto xl:px-0"
      >
        <div
          v-for="item in tokenCirculationEconomics"
          :key="item.id"
          class="flex flex-col-reverse items-center w-full md:w-auto md:mx-auto flex-wrap xl:w-auto xl:flex-row gap-2.5"
        >
          <div
            class="bg-[#FFFFFF05] w-full sm:w-auto sm:min-w-78 border border-solid border-[#FFFFFF21] min-h-49.5 rounded-[0.875rem]"
          >
            <div class="flex flex-col gap-1.5 pl-5.5 pr-6 pt-3.5">
              <p
                class="flex flex-row items-center justify-center gap-3.5 text-lg text-[#B696FF] sm:text-center"
              >
                {{ item.title }}
                <Closed v-if="item.id === 0" />
              </p>
              <div v-if="false" class="flex flex-row justify-between">
                <p>
                  Price, USD <template v-if="item.id === 0"> (Closed)</template>
                </p>
                <p>{{ item.price }}</p>
              </div>
              <div class="flex flex-row justify-between">
                <p>TGE, %</p>
                <p>{{ item.tge }}</p>
              </div>
              <div class="flex flex-row justify-between">
                <p>Cliff (M)</p>
                <p>{{ item.cliff }}</p>
              </div>
              <div class="flex flex-row justify-between">
                <p>Vesting (M)</p>
                <p>{{ item.vesting }}</p>
              </div>
            </div>
          </div>
          <div
            class="relative min-w-50 min-h-50 rounded-full"
            :style="`background: conic-gradient(#b696ff 0% ${item.percent}, #fff 0%);`"
          >
            <div
              class="absolute top-1/2 left-1/2 w-25 h-25 bg-[#151515] rounded-full text-[#b696ff] flex items-center justify-center -translate-x-1/2 -translate-y-1/2 text-2xl"
            >
              {{ item.percent }}
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="max-w-285 relative mx-5 pt-8 xl:mx-auto xl:pt-20">
          <p
            class="text-2xl tracking-wide text-center md:text-text-[2rem] xl:text-left"
          >
            {{ t('token-allocation') }}
          </p>

          <div
            class="flex flex-col mt-8 pb-8 xl:flex-row xl:mt-13 xl:pb-20 justify-between items-center"
          >
            <client-only>
              <div class="max-w-178 h-100">
                <Lottie src="/lottie/token-allocation.json" />
              </div>
            </client-only>
            <div class="flex flex-col max-w-77.5 w-full gap-3 mt-5 xl:mt-0">
              <div
                v-for="item in tokenAllocation"
                :key="item.id"
                class="flex flex-row justify-between"
                v-motion="{
                  initial: {
                    opacity: 0,
                  },
                  visibleOnce: {
                    opacity: 1,
                    transition: {
                      delay: `${item.id * 200}`,
                      type: 'keyframes',
                    },
                  },
                }"
              >
                <div class="flex flex-row items-center gap-2">
                  <div
                    class="w-3 h-3 rounded-sm"
                    :style="{ backgroundColor: item.color }"
                  />
                  <p class="text-sm md:text-base">
                    {{ item.title }}
                  </p>
                </div>
                <p class="text-sm md:text-base">{{ item.percent }}</p>
              </div>
            </div>
          </div>
        </div>
        <img
          alt="Blur"
          class="absolute left-0 bottom-0 -z-1"
          src="/assets/images/token/blur.svg"
        />
      </div>

      <div class="max-w-275 mx-auto pt-8 px-5 xl:py-10 xl:px-0">
        <p class="text-2xl md:text-[2rem] tracking-wide font-light">
          {{ t('emissions') }}
        </p>

        <div
          class="flex flex-col items-center mt-5 xl:flex-row xl:items-start xl:justify-between xl:mt-11.5"
        >
          <div class="w-full xl:max-w-132.5">
            <p
              class="opacity-60 text-sm leading-[1.5rem] tracking-wide md:text-lg font-light"
            >
              {{ t('the-below-graphs-are-used') }}
              <br /><br />
              {{ t('one-can-generally-expect') }}
            </p>
          </div>

          <div class="flex justify-center items-center w-full max-w-124 mt-5">
            <div
              class="flex flex-row flex-wrap justify-center items-center absolute z-1 gap-1.5 xl:gap-2.5 xl:left-auto xl:right-auto xl:left-5 xl:right-5"
            >
              <p
                class="bg-[#151515] border border-solid border-[#CB99FF] py-1.5 px-4 rounded-full text-xs md:text-sm"
                v-motion="{
                  initial: {
                    opacity: 0,
                  },
                  visibleOnce: {
                    opacity: 1,
                    transition: {
                      delay: 500,

                      type: 'keyframes',
                      ease: 'easeIn',
                    },
                  },
                }"
              >
                {{ t('circulating-supply') }}
              </p>
              <p class="text-[1.25rem] md:text-2xl">+</p>

              <p
                class="bg-[#151515] border border-solid border-[#CB99FF] py-1.5 px-4 rounded-full text-xs md:text-sm"
                v-motion="{
                  initial: {
                    opacity: 0,
                  },
                  visibleOnce: {
                    opacity: 1,
                    transition: {
                      delay: 1000,

                      type: 'keyframes',
                      ease: 'easeIn',
                    },
                  },
                }"
              >
                {{ t('treasury') }}
              </p>
              <p class="text-[1.25rem] md:text-2xl">=</p>

              <p
                class="bg-[#151515] border border-solid border-[#CB99FF] py-1.5 px-4 rounded-full text-xs md:text-sm"
                v-motion="{
                  initial: {
                    opacity: 0,
                  },
                  visibleOnce: {
                    opacity: 1,
                    transition: {
                      delay: 1500,

                      type: 'keyframes',
                      ease: 'easeIn',
                    },
                  },
                }"
              >
                {{ t('total-supply') }}
              </p>
            </div>
            <client-only>
              <div class="w-55 md:w-70">
                <Lottie src="/lottie/emissions.json" loop autoplay />
              </div>
            </client-only>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section>
    <div class="max-w-295 mx-auto pt-0 pb-8 xl:py-10 px-5">
      <p
        class="text-[#E0BDFF] tracking-wide leading-[2rem] text-xl max-w-138.5 xl:ml-10"
      >
        {{ t('the-emissions-schedule') }}
      </p>
      <div class="mt-5 xl:mt-13">
        <client-only>
          <Lottie src="/lottie/emissions-schedule.json" loop autoplay />
        </client-only>
      </div>
      <p class="mt-3 ml-2.5 text-sm xl:mt-9 xl:ml-25.5 xl:text-base">
        {{ t('unlock-tokens-by-month-total') }}
      </p>

      <div
        class="grid grid-cols-2 gap-5 ml-6 xl:flex xl:flex-wrap xl:flex-row xl:ml-21.5 xl:gap-6.5 mt-3.5"
      >
        <div
          v-for="item in tokensByMonth"
          :key="item.id"
          class="flex flex-row items-center gap-1.5"
        >
          <div
            class="min-w-2.5 h-2.5 rounded-sm"
            :style="{ backgroundColor: item.color }"
          />

          <p class="text-sm xl:text-base">
            {{ item.title }}
          </p>
        </div>
      </div>
    </div>
  </section>

  <section>
    <Supported class="pt-8 xl:pt-32.5 pb-17" />
  </section>

  <section>
    <InstallSection class="px-5" />
  </section>
</template>

<style scoped>
@reference "tailwindcss";
.slider-content {
  background: linear-gradient(
    180deg,
    rgba(255, 176, 240, 0.1) 0%,
    rgba(117, 64, 238, 0.1) 100%
  );
}
</style>
